var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineBucketSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.4 17.46-2.83-2.83c-1.24-1.24-1.24-2.66 0-3.89l4.72-4.72c.29-.29.77-.29 1.06 0l5.19 5.19c.27.27.41.62.41 1s-.15.74-.41 1l-4.25 4.25c-.6.62-1.26.93-1.94.93-.68 0-1.33-.31-1.95-.93zm-1.76-5.67c-.32.32-.49.62-.49.89 0 .26.16.56.49.89l2.83 2.83c.65.65 1.12.65 1.77 0l4.19-4.19-4.6-4.61-4.19 4.19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.3 7.07-.94-.94a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l.94.94c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22zM4.69 12.67a.75.75 0 0 1 .72-.78l10.68-.47c.41-.04.76.3.78.72.02.41-.3.76-.72.78l-10.68.47h-.03a.75.75 0 0 1-.75-.72z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.24 17.09c0-1.08 1.15-2.41 1.5-2.79.28-.31.82-.31 1.1 0 .35.38 1.5 1.72 1.5 2.79a2.04 2.04 0 0 1-2.04 2.06c-1.13 0-2.06-.92-2.06-2.06zm1.5 0a.56.56 0 1 0 1.12 0c-.01-.21-.25-.65-.56-1.09-.31.44-.56.88-.56 1.09z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 5.43-2.32 7.75-7.75 7.75H9zM2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25V9c0-4.61-1.64-6.25-6.25-6.25H9C4.39 2.75 2.75 4.39 2.75 9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineBucketSquare);
export default __webpack_public_path__ + "static/media/vuesax-outline-bucket-square.3dc302ad6d7519626e944ab4984373d1.svg";
export { ForwardRef as ReactComponent };